import { Plus } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SIDEBAR_PILL_BUTTON,
  SIDEBAR_PILL_ICON_BUTTON,
} from "./sidebar-section-toggle";

export type SidebarFilter = "all" | "recent" | "unread";

interface SectionHeaderPillProps {
  filter: SidebarFilter;
  onFilterChange: (value: SidebarFilter) => void;
  onCreateClick?: () => void;
  onCreateOptions?: { label: string; onClick: () => void }[];
}

/**
 * The All/Recent/Unread filter pill + optional + button (or +
 * dropdown menu when `onCreateOptions` is supplied) shown in the
 * Channels and Direct Messages section headers. Hidden until the
 * section is hovered (group/section opacity).
 */
export function SectionHeaderPill({
  filter,
  onFilterChange,
  onCreateClick,
  onCreateOptions,
}: SectionHeaderPillProps) {
  return (
    <div className="ml-auto flex items-center rounded border border-border/50 overflow-hidden opacity-0 group-hover/section:opacity-100 transition-opacity duration-150">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className={SIDEBAR_PILL_BUTTON}>
            {filter === "all"
              ? "All"
              : filter === "recent"
                ? "Recent"
                : "Unread"}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[100px]">
          {(["recent", "all", "unread"] as const).map((value) => (
            <DropdownMenuCheckboxItem
              key={value}
              checked={filter === value}
              onCheckedChange={() => onFilterChange(value)}
              className="text-xs"
            >
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      {onCreateClick && !onCreateOptions && (
        <>
          <div className="w-px h-3 bg-border/50" />
          <Button
            type="button"
            variant="ghost"
            onClick={onCreateClick}
            className={SIDEBAR_PILL_ICON_BUTTON}
          >
            <Plus size={10} weight="Bold" />
          </Button>
        </>
      )}
      {onCreateOptions && (
        <>
          <div className="w-px h-3 bg-border/50" />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className={SIDEBAR_PILL_ICON_BUTTON}>
                <Plus size={10} weight="Bold" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[140px]">
              {onCreateOptions.map((opt) => (
                <DropdownMenuItem
                  key={opt.label}
                  onClick={opt.onClick}
                  className="text-xs"
                >
                  {opt.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      )}
    </div>
  );
}
